export default "__VITE_ASSET__DVFAN3G6__"